import React, { useState } from "react";
import styles from "./RsvpSchedule.module.css";
import {
  InputField,
  SubmitButton,
  TextComponent,
  TextHeader,
} from "../../../../components";
import { AiFillPlusCircle } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { setRSVP } from "../../../../Store/Actions/EventPlanningActions";
const CloseIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 28 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0773 23.0073L19.7087 15.0542L27.0775 7.10081L21.103 0.652335L13.7342 8.60568L6.36558 0.652567L0.390883 7.10123L7.75946 15.0543L0.390667 23.0077L6.36519 29.4562L13.734 21.5028L21.1026 29.4559L27.0773 23.0073Z"
      fill="#ED73AA"
    />
  </svg>
);
const RsvpSchedule = () => {
  const navigate = useNavigate();
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const { state } = useLocation();
  const eventData =  state?.eventData;
  const dispatch = useDispatch();

  console.log(RSVP);
  const next = () => {
    let data = [...scheduleArray]
    if (!data[data.length - 1].title || !data[data.length - 1].description) {
        dispatch(showAlert({type: "Error", title: 'Schedule', message: 'Please fill all schedule details.!', status: 400 }))
        return
    } else {
        let resdata = {
            ...RSVP,
            schedules: scheduleArray
        }
        dispatch(setRSVP(resdata))
        navigate("/events/rsvp/rsvpfamily", {
          state: { headrTitle: "RSVP", eventData: eventData },
        })
    }
}
  const [scheduleArray, setscheduleArray] = useState(
    RSVP?.schedules?.length > 0
      ? RSVP?.schedules
      : [
          {
            title: "",
            description: "",
          },
        ]
  );
  return (
    <div>
      <TextHeader
        text={"5. Schedule"}
        containerClass={styles.textContainer}
        textClass={styles.textHeading}
      />
      {scheduleArray?.map((item, index) => {
        return (
          <div style={{marginTop: "50px"}}>
            <InputField
              label="Title"
              styles={styles.input1}
              rightIcon={CloseIcon}
              onRightIconPress={() => {
                let array = [...scheduleArray];
                if (array.length == 1) return;
                array.splice(index, 1);
                setscheduleArray(array);
              }}
              value={item.title}
              onChange={(e) => {
                let array = [...scheduleArray];
                array[index].title = e.target.value;
                setscheduleArray(array);
              }}
              placeholder={"Add title"}
            />
            <div className={styles.middlecontainer}>
              <TextComponent text={"Description"} textClass={styles.text} />
            </div>

            <div className={styles.main_input}>
              <textarea
               onChange={(e) => {
                let array = [...scheduleArray]
                array[index].description = e.target.value;
                setscheduleArray(array)
            }}
            value={item.description}
                className={styles.mainInput}
                placeholder={'Add description'}

              />
            </div>
          </div>
        );
      })}
      {/* <InputField styles={styles.input1} label="Title" placeholder="Trish" />

      <div className={styles.middlecontainer}>
        <TextComponent text={"Description"} textClass={styles.text} />
      </div>

      <div className={styles.main_input}>
        <textarea className={styles.mainInput} placeholder="Write here...." />
      </div> */}
      <div className={styles.iconContainer}>
        <div className={styles.innerContainer} onClick={()=>{
          let data = [...scheduleArray]
          if (!data[data.length - 1].title || !data[data.length - 1].description) {
              dispatch(showAlert({type: "Error", title: 'Schedule', message: 'Please fill all schedule details.!', status: 400 }))
              return
          }
          data.push({
              title: '',
              description: ''
          })
          setscheduleArray(data)
        }}>
          <AiFillPlusCircle className={styles.icon} size={50} />
          <TextComponent text={"Add More"} textClass={styles.innertext} />
        </div>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={10} lg={8} xl={7}>
          <SubmitButton
            btnClass={styles.btnClass}
            title="Next"
            onClick={next }
          />
        </Col>
      </Row>
    </div>
  );
};

export default RsvpSchedule;
